import { ButtonSize } from 'builder/components/Button'
import { useMediaQueries } from './useMediaQueries'

export const useResponsiveButtonSize = () => {
  const { isTablet } = useMediaQueries()
  return isTablet ? ButtonSize.small : ButtonSize.default
}
